import type { FC, PropsWithChildren } from 'react';
import { Grid, StripeNavigation, StripeTitle } from '@george-labs.com/design-system';

import { shouldUseEmbeddedLayout, useStripeHeaderStickyOffset } from '@shared/core-ui-layout';
import { useActiveMenuItem } from '@shared/products-core';

import type { NavigationProps, StripeProps } from './LayoutProps';
import styles from './MainLayout.module.scss';

type Props = NavigationProps & StripeProps;

export const MainLayout: FC<PropsWithChildren<Props>> = ({
    navigationItems,
    stripeHeader,
    alwaysAllowStripeNavigation,
    children,
}) => {
    const stickyOffset = useStripeHeaderStickyOffset();
    const activeMenuItem = useActiveMenuItem();
    const { label, pageTitle = label } = activeMenuItem;
    const stripeCenterComponent =
        shouldUseEmbeddedLayout() && !alwaysAllowStripeNavigation ? (
            <StripeTitle>{pageTitle}</StripeTitle>
        ) : (
            <StripeNavigation
                items={navigationItems}
                selectedItem={activeMenuItem}
                title={pageTitle}
            />
        );

    return (
        <div className={`${styles.productsMainLayout} pb-2`}>
            <stripeHeader.type
                {...(stripeHeader.props as Record<string, never>)}
                center={stripeCenterComponent}
                stickyOffset={stickyOffset}
                sticky
                className={styles.layoutStripe}
            />
            <Grid data-cy="content-container" className="mt-4" fluid={false}>
                {children}
            </Grid>
        </div>
    );
};
